
<div>
    <f-title :title="title" v-if="title" class="mt-0" />
    <div :class="border ? 'lm-border pa-2' : ''">
        <v-row class="no-frame mt-n1">
            <v-col class="no-frame pr-2 col-6">
                <f-currency-field
                    v-model         = "data.priceOriginal"
                    class           = "money"
                    :label          = "$t('invoice.price.original')"
                    :readonly       = "readonly"
                    :rules          = "[originalPriceRule]"
                    :error-messages = "priceOriginalError"
                    hide-details=""
                />
                <f-currency-field
                    class         = "money mt-2"
                    :label        = "$t('invoice.cost.material')"
                    :readonly     = "readonly"
                    v-model       = "data.costMaterial"
                    :rules        = "[costPriceRule]"
                    :error-messages = "costMaterialError"
                    hide-details=""
                />
                <f-currency-field
                    v-model       = "data.costWage"
                    class         = "money mt-2"
                    :label        = "$t('invoice.cost.wage')"
                    :readonly     = "readonly"
                    :rules        = "[costPriceRule]"
                    :error-messages = "costWageError"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-2 col-6">
                <f-currency-field
                    v-model   = "data.priceRecommended"
                    class     = "money"
                    :label    = "$t('invoice.price.recommended')"
                    :readonly = "readonly"
                    :rules    = "[recomendationRule]"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame mt-5" >
            <v-col class="no-frame">
                <v-textarea
                    v-model="data.notice"
                    :rules    = "[requiredOnTerminationRule]"
                    rows      = "3"
                    :label    = "$t('repair.bid.label.measure')"
                    :readonly = "readonly"
                    :disabled = "readonly"
                    no-resize
                />
            </v-col>
        </v-row>
    </div>
</div>
